import axios from 'axios'
import notifService from '../../services/notifService'

export const getSelling = async (context, pagination) => {
  let res = await axios
    .get('/cms/sellings', {
      params: pagination
    })
    .then(response => {
      context.commit('getSelling', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const listSelling = async (context, pagination) => {
  axios
    .get('/cms/sellings', {
      params: pagination
    })
    .then(response => {
      context.commit('listSelling', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const addSelling = async (context, val) => {
  return await axios
    .post('/cms/sellings/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editSelling = async (_context, val) => {
  return await axios
    .put('/cms/sellings/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteSelling = async (_context, val) => {
  return await axios
    .delete('/cms/sellings/delete/' + val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const sellingForm = (context, val) => {
  context.commit('sellingForm', val)
}
